import { Col, Empty, Tooltip } from 'antd'
import Button from 'components/Button/index'
import Pagination from 'components/Pagination'
import SearchInput from 'components/SearchInput'
import {
  ReportWrapper,
  RowNumberDataReport,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import ReportSearchFilter from 'components/UIComponents/ReportSearchFilter'
import {
  Container,
  Content,
  ContentDiv,
  Contents,
  Dividers,
  FilterHeader,
  FilterHeading,
  FilterText,
  FilterTextWithUnderLine,
  Footer,
  MarginLeft,
  MarginRightSmall,
  RowHeader,
  VerticalDivider,
  Wrappera,
} from 'components/UIComponents/ReportSearchFilter/Style/style.js'
import CloseFilter from 'components/icons/CloseFilter'
import { UserName } from 'modules/Dashboard/Partials/style'
import ExportButton from 'modules/Report/Partials/Export/ExportButton.js'
import CityFilter from 'modules/Report/Partials/Filter/CityFilter.js'
import DegreeAndDepartmentFilter from 'modules/Report/Partials/Filter/DegreeDepartmentFilter.js'
import React, { useState } from 'react'
import { yesNo } from '../../ExcelHeaderData'
import DateRangeFilter from '../Filter/DateRangeFilter'
import RankFilter from '../Filter/RankFilter'
const PageContent = ({
  pageHeader,
  applyFilter,
  clearFilter,
  column,
  tableData,
  filterData,
  currentPage,
  onPageChange,
  searchRoleValue,
  setSearchRoleValue,
  onChange,
  loadingRole,
  hasProp,
  clickedExcel,
  excelLoading,
  excel,
  isExcel,
  setIsExcel,
  tooltip,
  createdAtStart,
  createdAtEnd,
  setCreatedAtEnd,
  onStatusFilterChanges,
  clear,
  setClear,
  error,
  setError,
  dataSign,
  setDegreeList,
  degreeList,
  filterCancel,
  setFilterCancel,
  pdfCellWidth,
  setSearchDegree,
  loadingDep,
  setDateError,
  flag,
  HAlign,
  columnWidths,
  orientation,
  corporateName,
  loadMoreData,
  count,
  pages,
  degreeLoader,
  subEvents,
}) => {
  const isExcelButtonEnabled = subEvents?.includes('EXPORT TO EXCEL')
  const isPdftButtonEnabled = subEvents?.includes('EXPORT TO PDF')
  const [open, setOpen] = useState(true)
  const [page, setPage] = useState(1)
  const onDegreeFilterChange = data => {
    setDegreeList(data)
    setPage(0)
  }
  const expandedRowRender = record => {
    if (record.campus) {
      return (
        <table>
          <tbody>
            <tr key={record.id}>
              <td width={'45%'}></td>
              {record.campus.map((item, index) => (
                <tr key={item}>
                  <li>
                    <RowNumberDataReport>
                      {index + 1 + ') '}&nbsp;{item}
                    </RowNumberDataReport>
                  </li>
                </tr>
              ))}
              <td></td>
            </tr>
          </tbody>
        </table>
      )
    } else {
      return null
    }
  }
  const renderingElement = (
    <ReportWrapper>
      <RowHeader>
        <Col span={21}>
          <UserName>{pageHeader}</UserName>
        </Col>
        <Col span={2}>
          {(isExcelButtonEnabled || isPdftButtonEnabled) && (
            <UserName>
              <ExportButton
                corporateName={corporateName}
                pdfCellWidth={pdfCellWidth}
                title={pageHeader}
                dataset={excel}
                clickedExcel={clickedExcel}
                data={isExcel}
                setIsExcel={setIsExcel}
                count={tableData?.count || 0}
                loading={excelLoading}
                horizontalAlignment={HAlign}
                columnWidth={columnWidths}
                orientation={orientation}
                isExcelButtonEnabled={isExcelButtonEnabled}
                isPdftButtonEnabled={isPdftButtonEnabled}
              />
            </UserName>
          )}
        </Col>
      </RowHeader>
      <ReportSearchFilter
        setOpen={setOpen}
        open={open}
        searchValue={searchRoleValue}
        setSearchValue={setSearchRoleValue}
        currentCount={
          tableData?.count < 10
            ? tableData?.count || 0
            : (tableData?.page + 1) * 10 - 10 + tableData?.result?.length
        }
        totalCount={tableData?.count}
      />
      <Dividers />
      <Wrappera>
        <Content isOpen={open}>
          <ContentDiv width="100%">
            {filterData?.map(item => (
              <>
                <Contents key={item.id}>
                  <FilterHeader>
                    <FilterHeading>
                      <FilterText>{item.headerName}</FilterText>
                      {item.headerName.indexOf('Date') === -1 &&
                      item.headerName.indexOf('Rank') === -1 ? (
                        ''
                      ) : (
                        <FilterTextWithUnderLine
                          onClick={() => {
                            item.headerName.indexOf('Date') === -1
                              ? setClear(true)
                              : item.clearDate(true)
                          }}
                        >
                          {'Clear All'}
                        </FilterTextWithUnderLine>
                      )}
                    </FilterHeading>
                    {item.headerName.indexOf('Date') === -1 &&
                    item.headerName.indexOf('Offer') === -1 &&
                    item.headerName.indexOf('Rank') === -1 ? (
                      <SearchInput
                        background="#F8F8F8"
                        width={'100%'}
                        placeholder={'Search by Keyword'}
                        bordered={false}
                        searchValue={item.searchValue}
                        setSearchValue={item.setSearchValue}
                      />
                    ) : (
                      ''
                    )}
                  </FilterHeader>
                  <Container
                    width="500"
                    overflow={item.headerName.includes('Date') ? 'none' : ''}
                    height={item.headerName.includes('Degree') ? '0' : 0}
                  >
                    {item.headerName.includes('Date') ? (
                      <DateRangeFilter
                        id={item.id}
                        isEmpanelled={true}
                        createdAtStart={item.createdAtStart}
                        createdAtEnd={item.createdAtEnd}
                        setCreatedAtStart={item.setCreatedAtStart}
                        setCreatedAtEnd={item.setCreatedAtEnd}
                        clearDate={item.clear}
                        setClearDate={item.clearDate}
                        setDateError={setDateError}
                      />
                    ) : item.headerName.includes('Offer') ? (
                      <FilterCheckBoxComp
                        options={yesNo}
                        value={item.statusFilters}
                        onChange={event =>
                          onStatusFilterChanges(item.headerName, event)
                        }
                        labelParam="name"
                        valueParam="value"
                        padding="0.5rem 10px !important"
                      />
                    ) : item.headerName.includes('Rank') ? (
                      <RankFilter
                        clear={clear}
                        setClear={setClear}
                        error={error}
                        setError={setError}
                        dataSign={dataSign}
                        setRank={item.setRank}
                        setRankSign={item.setRankSign}
                      />
                    ) : item.headerName.includes('Degree') ? (
                      <DegreeAndDepartmentFilter
                        degreeList={item.data ? item.data : []}
                        setDegreeList={onDegreeFilterChange}
                        searchQuery={item.searchQuery}
                        degree={degreeList}
                        filterCancel={filterCancel}
                        setFilterCancel={setFilterCancel}
                        setSearchDegree={setSearchDegree}
                        loading={loadingDep}
                        page={pages}
                        count={count}
                        loadMoreData={loadMoreData}
                        degreeLoader={degreeLoader}
                      />
                    ) : (
                      <CityFilter
                        setPage={setPage}
                        page={page}
                        length={item?.data?.result?.length || 0}
                        value={item.value}
                        setValue={item.setValue}
                        search={item.searchValue}
                        setSearch={item.setSearchValue}
                        cityData={item.data}
                        cityDetails={item.apicall}
                        setLoading={item.setLoading}
                        loading={item.loading}
                        valueParam={item.valueParam}
                        labelParam={item.labelParam}
                        flag={item.flag}
                      />
                    )}
                  </Container>
                </Contents>
                <VerticalDivider type="vertical" />
              </>
            ))}
          </ContentDiv>
        </Content>
        <Dividers />
        <Footer style={{ display: open ? '' : 'none' }}>
          <MarginRightSmall
            onClick={() => {
              setOpen(false)
            }}
          >
            <CloseFilter />
          </MarginRightSmall>
          <div>
            <Button.Secondary
              height="35px"
              htmlType="Clear"
              text={'Clear Filter'}
              width={'144px'}
              onClick={clearFilter}
            />
          </div>
          <MarginLeft>
            <Tooltip
              placement="topLeft"
              title={
                !tooltip
                  ? 'Kindly Select Filter Option Before Submitting the Data'
                  : ''
              }
            >
              <Button.Primary
                height="35px"
                htmlType="Save Filter"
                text={'Apply'}
                width={'144px'}
                onClick={applyFilter}
              />
            </Tooltip>
          </MarginLeft>
        </Footer>
      </Wrappera>
      <Dividers />
      <StyledTable
        width="100vw"
        rowKey={(record, index) => index}
        columns={column}
        pagination={false}
        dataSource={tableData?.result || []}
        onChange={onChange}
        locale={{
          emptyText: (
            <Empty
              description={
                !hasProp
                  ? 'Kindly Select Filter Option to View the Data'
                  : 'No Roles Found'
              }
            />
          ),
        }}
        loading={loadingRole}
        scroll={{
          x: 2000,
          y: 600,
        }}
        // expandable={{
        //   expandedRowRender,
        //   rowExpandable: record =>
        //     !!record.campus && record?.campus?.length > 1,
        //   expandRowByClick: true,
        // }}
      />
      <Pagination
        totalPages={tableData?.count}
        pageSize={tableData?.limit}
        onChange={onPageChange}
        current={currentPage}
      />
    </ReportWrapper>
  )

  return <>{renderingElement}</>
}
export default PageContent
